import { RouteObject } from "react-router-dom";
import Logout from "./auth/logout";
import LogoutCallback from "./auth/logoutCallback";
import Signin from "./auth/signin";
import SignInCallback from "./auth/signInCallback";
import SilentRenew from "./auth/silentRenew";
import { Home } from "./components/home/home";
import { AccountRoutes } from "./components/account/accountRoutes";
import { ConfiguationSettings } from "./components/common/configuration";
import RequireAuth from "./auth/requireAuth";
import { AdminRoutes } from "./components/admin/adminRoutes";
import { SystemRoutes } from "./components/system/systemRoutes";
import {
  QuestionnaireContainer,
  QuestionnaireType,
} from "./components/questionnaire/questionnaireForm/questionnaireContainer";
import { QuestionnaireRoutes } from "./components/questionnaire/questionnaireRoutes";
import { HereNowRoutes } from "./components/herenow/herenowRoutes";
import { Bloomberg } from "./components/home/bloomberg";
import { CommunityRoutes } from "./components/community/communityRoutes";
import { CommunityContainer } from "./components/community/communityContainer";
import { permissions, roles } from "./assets/configuration/claimSettings";
import { HomeDemo } from "./components/home/homedemo";
import { ConfigurationSectionType } from "./assets/configuration";
import { Privacy } from "./components/home/privacy";
import { Support } from "./components/home/support";
import { DeleteAccount } from "./components/home/deleteAccount/deleteAccount";
import { ServiceRequestContainer } from "./components/serviceRequest/serviceRequestContainer";
import { CommunityNeighborhoodSettings } from "./components/community/communityNeighborhood/communityNeighborhoodSettings";

export const AppRoutes: RouteObject[] = [
  { index: true, element: <Home /> },
  { path: "homedemo", element: <HomeDemo /> },
  { path: "bloomberg", element: <Bloomberg /> },
  { path: "privacy", element: <Privacy /> },
  { path: "support", element: <Support /> },
  { path: "deleteaccount", element: <DeleteAccount /> },
  {
    path: "systemsettings",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ViewSystemSettingSection,
        ]}
        requiredRoles={[roles.SystemAdmin]}
      >
        {" "}
        <ConfiguationSettings
          sectionType={ConfigurationSectionType.System}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "accountsettings",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ViewAccountSettingSection,
        ]}
        requiredRoles={[roles.SystemAdmin]}
      >
        {" "}
        <ConfiguationSettings
          sectionType={ConfigurationSectionType.Account}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "adminsettings",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ViewAdminSettingSection,
        ]}
        requiredRoles={[roles.SystemAdmin, roles.CommunityAdmin]}
      >
        {" "}
        <ConfiguationSettings
          sectionType={ConfigurationSectionType.Admin}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "neighborhoods",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageCommunity,
        ]}
        requiredRoles={[roles.SystemAdmin, roles.CommunityAdmin]}
      >
        <CommunityNeighborhoodSettings />
      </RequireAuth>
    ),
  },
  {
    path: "questionnairesettings",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ViewQuestionnaireSettingSection,
        ]}
        requiredRoles={[roles.SystemAdmin]}
      >
        {" "}
        <ConfiguationSettings
          sectionType={ConfigurationSectionType.Questionnaire}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "herenowsettings",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ViewPopHubSettingSection,
        ]}
        requiredRoles={[roles.SystemAdmin]}
      >
        {" "}
        <ConfiguationSettings
          sectionType={ConfigurationSectionType.PopHub}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "questionnaire",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageQuestionnaire,
        ]}
      >
        {" "}
        <QuestionnaireContainer />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "survey",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageQuestionnaire,
        ]}
        requiredRoles={[roles.SystemAdmin]}
      >
        {" "}
        <QuestionnaireContainer
          questionnaireType={QuestionnaireType.Survey}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "poll",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageQuestionnaire,
        ]}
      >
        {" "}
        <QuestionnaireContainer
          questionnaireType={QuestionnaireType.Poll}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "feedback",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageQuestionnaire,
        ]}
      >
        {" "}
        <QuestionnaireContainer
          questionnaireType={QuestionnaireType.Feedback}
        />{" "}
      </RequireAuth>
    ),
  },
  {
    path: "serviceRequest",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageServiceRequest,
        ]}
      >
        <ServiceRequestContainer />
      </RequireAuth>
    ),
  },
  { path: "signin", element: <Signin /> },
  { path: "signin-oidc", element: <SignInCallback /> },
  { path: "logout", element: <Logout /> },
  { path: "silentrenew", element: <SilentRenew /> },
  { path: "logout/callback", element: <LogoutCallback /> },
    {
    path: "community",
    element: (
      <RequireAuth
        requiredPermission={[
          permissions.SystemFull,
          permissions.ManageCommunity,
        ]}
        requiredRoles={[roles.CommunityAdmin, roles.SystemAdmin]}
      >
        <CommunityContainer />
      </RequireAuth>
    ),
    children: [
      {
        path: ":communityId",
      },
    ],
  },
  AccountRoutes,
  AdminRoutes,
  HereNowRoutes,
  QuestionnaireRoutes,
  SystemRoutes,
  CommunityRoutes,
];
